import type { ComponentPropsWithoutRef } from "react";
import { Fragment } from "react";

import type { WithAsChild } from "../../../../types/withAsChild.types";

export const FragmentAsChild = (
  props: WithAsChild<ComponentPropsWithoutRef<typeof Fragment>>,
) => <Fragment>{props.children}</Fragment>;
